<template>
  <div class="countersign">
    <div class="addnum">
      <!--您有{num}次补签机会-->
      <van-icon v-if="$route.query.isBanner == 0 && $route.query.isApp == 1" id="backIcon" @click="$router.back()" :name="isDirection ? 'arrow' : 'arrow-left'" />
      <p class="p-content" v-html="$t('300163', { num: usersignMsg.availableCountersignNum })"></p>
      <!--获得补签机会-->
      <p class="p-link" @click="tomoney">{{ $t("300164") }}<i :class="isDirection ? 'iconfont icon-left' : 'iconfont icon-right'"></i></p>
      <div class="datarender">
        <dl
          :class="{
            nosign: item.status == 1 || item.status == 3 || item.status == 0
          }"
          v-for="(item, index) in usersignMsg.signDateList"
          :key="index"
        >
          <dt>
            <img :src="getImgurl(giftday[index], '.png', item.status)" alt="" />
          </dt>
          <dd>
            {{
              item.signDate
                .split("-")
                .slice(1)
                .join(".")
            }}
          </dd>
          <div
            v-show="item.status === 1"
            class="dialog"
            @click="addsigns(item.signDate, index)"
          >
            <div>
              <!--可补签-->
              <span>{{ $t("300165") }}</span>
            </div>
          </div>
        </dl>
      </div>
    </div>
    <van-popup :close-on-click-overlay="false" class="reward" v-model="isget">
      <div class="Tipsdialog" v-if="isshow">
        <div class="Tips">
          <!--提示-->
          <p>
            <svg
              slot="image"
              v-if="!usersignMsg.isGetCountersign"
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-tishi-1"></use>
            </svg>
            <span v-if="usersignMsg.isGetCountersign">{{ $t("300166") }}</span>
          </p>
          <div class="main p" v-if="usersignMsg.isGetCountersign">
            <!--您还没有补签次数，当日净充值≥{num}{symbol}，即可获得1次补签机会-->
            <p>
              {{
                $t("300168", {
                  num: signconfig.rechargeAmount,
                  symbol: "USDT"
                })
              }}
            </p>
          </div>
          <div class="main p" v-if="!usersignMsg.isGetCountersign">
            <!--补签次数已上限-->
            <p>{{ $t("300170") }}</p>
          </div>
          <div
            @click="closedialog"
            v-if="!usersignMsg.isGetCountersign"
            class="OK"
          >
            <span>{{ $t("300141") }}</span>
          </div>
          <div v-if="usersignMsg.isGetCountersign" class="foot">
            <!--取消-->
            <span class="left" @click="closedialog">{{ $t("300111") }}</span>
            <!--去充值-->
            <span class="right" @click="tomoney">{{ $t("300102") }}</span>
          </div>
        </div>
      </div>
      <ReceiveDialog
        :addtitle="title"
        :receive="receive"
        :closegift="closegift"
        :getconfig="getconfig"
      ></ReceiveDialog>
    </van-popup>
  </div>
</template>

<script>
import { getsign, usermsg, addsign, signConfigApi } from "../api/resource";
import ReceiveDialog from "../compontents/Receivedialog.vue";
import { Popup,Icon } from "vant";
import { mapGetters } from "vuex";
export default {
  components: { ReceiveDialog, vanPopup: Popup,vanIcon: Icon },
  data() {
    return {
      language: "",
      giftday: [],
      count: 0,
      isshow: false,
      usersignMsg: {
        availableCountersignNum: 0,
        isGetCountersign: true,
        signDateList: []
      },
      userMsg: {},
      getconfig: [],
      title: "",
      receive: false,
      signconfig: {},
      isget: false
    };
  },
  computed: {
    ...mapGetters(["isDirection"])
  },
  watch: {
    receive(neval, old) {
      this.isget = neval;
    },
    isshow(newval, old) {
      this.isget = newval;
    }
  },
  created() {
    this.title = this.$t("300167"); // 补签成功
    window.document.documentElement.setAttribute(
      "dir",
      this.isDirection ? "rtl" : "ltr"
    );
    getsign().then(res => {
      this.usersignMsg = res.data;
      if (this.usersignMsg.signDateList.length > 0) {
        this.usersignMsg.signDateList.forEach((v, i) => {
          this.giftday.push({
            signed: "pumpkin_light@2x",
            nosign: "pumpkin_dark@2x"
          });
        });
      }
    });
    usermsg().then(res => {
      this.userMsg = res.data;
    });
    signConfigApi().then(res => {
      this.signconfig = res.data;
    });
  },
  methods: {
    sign() {
      this.isshow = true;
    },
    //关闭弹框
    closegift(val) {
      let page = document.querySelector(".countersign");
      if (this.receive) {
        page.style.position = "fixed";
        page.style.top = 0 + "px";
        page.style.left = 0 + "px";
        page.style.overflow = "hidden";
      } else {
        page.style.position = "";
        page.style.overflow = "hidden";
      }
      this.receive = val;
    },
    addsigns(date, index) {
      if (this.usersignMsg.availableCountersignNum > 0) {
        addsign({ signDate: date }).then(res => {
          this.getconfig = res.data;
          getsign().then(res => {
            this.usersignMsg = res.data;
          });
          if (index == 2) {
            this.isget = res.data[0].isThisAward;
          } else if (index == 4) {
            this.isget = res.data[1].isThisAward;
          } else if (index == 6) {
            this.isget = res.data[2].isThisAward;
          }
          this.receive = true;
        });
        return;
      } else {
        this.sign();
      }
    },
    tomoney() {
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appRecharge,
        { code: 200 },
        data => {}
      );
    },
    getImgurl(item, type, status) {
      if (!item) return;
      let a =
        status === 1 || status === 3 || status === 0
          ? item.nosign
          : item.signed;
      let b = require("../assets/images/anniversary/" + a + type);
      return b;
    },
    closedialog() {
      this.isshow = false;
      this.isover = false;
    }
  }
};
</script>
<style lang="scss" scoped>
[dir="ltr"] .datarender {
  dl {
    &:nth-child(1) {
      margin-left: 0;
    }
    &:nth-child(5) {
      margin-left: 0;
    }
  }
}
[dir="rtl"] .datarender {
  &:nth-child(1) {
    margin-right: 0;
  }
  &:nth-child(5) {
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
[dir="ltr"] .datarender dl {
  &:nth-child(1) {
    margin-left: 0;
  }
  &:nth-child(5) {
    margin-left: 0;
  }
}
[dir="rtl"] .datarender > dl {
  &:nth-child(1) {
    margin-right: 0;
  }
  &:nth-child(5) {
    margin-right: 0;
  }
}
</style>
<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
.Tipsdialog {
  // width: 100%;
  // height: 100%;
  // position: relative;
  // background: rgba($color: #000000, $alpha: 0.3s);
  // top: 0;
  // left: 0;
  .Tips {
    // position: absolute;
    // left: 50%;
    // top: 50%;\
    > p {
      span {
        font-size: torem(16);
        font-weight: 600;
        color: #fff;
      }
    }
    padding: torem(24);
    .main {
      > p {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: torem(14);
        b {
          font-size: torem(16);
          font-weight: 600;
        }
      }
    }
    // transform: translate(-50%, -50%);
    width: torem(312);
    background: #2a2d35;
    border-radius: torem(16);
    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(255, 199, 43, 1);
      font-size: torem(16);
      padding-top: torem(5);
      .icon {
        width: torem(33);
        height: torem(33);
      }
    }
    .addnum {
      p {
        font-size: torem(12);
        text-align: center;
        color: #fff;
      }
      margin-bottom: torem(6);
    }
  }
}
.rewarddialog {
  background: transparent !important;
}
.fillcontain {
  .countersign {
    /deep/ .van-popup {
      overflow-y: visible;
    }
  }
}

.reward {
  background: transparent;
  display: flex;
  // overflow: none !important;
  justify-content: center;
  .main {
    p {
      line-height: torem(21);
    }
  }
}
.countersign {
  width: 100vw;
  height: 100vh;
  background: #0E0803;
  overflow: hidden;
}
.countersign .addnum {
  padding: torem(24) torem(16);
  #backIcon{
    color: #FFF;
    margin: torem(0) torem(0) torem(8);
    font-size: torem(18);
  }
  p.p-content{
    font-size: torem(16);
    color: #fff;
    margin-bottom: torem(12);
  }
  p.p-link{
    font-size: torem(12);
    color: #ffc72b;
    i {
      font-size: torem(12);
      font-weight: lighter;
    }
  }
}
.dialog {
  position: absolute;
  border-radius: torem(12);
  width: torem(76);
  height: torem(86);
  top: 0;
  left: 0;
  background: rgba(14, 8, 3, 0.30);
  backdrop-filter: blur(3px);
  > div {
    width: torem(76);
    height: torem(86);
    border-radius: torem(12);
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: torem(12);
      display: inline-block;
      width: torem(75);
      text-align: center;
      word-break: normal;
      color: #ffc72b;
      font-weight: 600;
    }
  }
}
.datarender {
  display: flex;
  flex-wrap: wrap;
  margin-top: torem(24);
  > dl {
    width: torem(78);
    height: torem(88);
    position: relative;
    border-radius: torem(12);
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 2px solid #ffc72b;
    box-sizing: border-box;
    align-items: center;
    margin-left: torem(3.5);
    margin-right: torem(3.5);
    margin-top: torem(7);
    dd {
      color: #fff;
      font-size: torem(12);
    }
    &:nth-child(7) {
      width: torem(165);
      .dialog {
        width: torem(163);
        > div {
          width: torem(160) !important;
          text-align: center;
        }
      }
    }
  }
  img {
    width: torem(64);
    height: torem(46);
  }
}

.foot {
  display: flex;
  justify-content: space-around;
  align-items: center;
  span {
    display: inline-block;
    width: torem(124);
    height: torem(44);
    // padding: torem(10) 0;
    text-align: center;
    line-height: torem(44);
    border-radius: torem(4);
  }
  .left {
    color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.1);
    font-size: torem(14);
  }
  .right {
    background: #ffc72b;
    color: #333333;
    font-size: torem(14);
  }
}
.nosign {
  border-color: rgba(255, 255, 255, 0.4) !important;
}
.Tipsdialog {
  > .Tips {
    > .p {
      p {
        width: 100%;
        text-align: center;
        color: #fff;
      }
      padding: torem(30) 0;
      font-size: torem(14) !important;
    }
  }
}

.OK {
  text-align: center;
  span {
    width: torem(264);
    height: torem(44);
    text-align: center;
    line-height: torem(44);
    display: inline-block;
    border-radius: torem(4);
    background: rgba(255, 199, 43, 1);
    color: rgba(51, 51, 51, 1);
    font-size: torem(14);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Countersign.vue